import { REQUEST_STATUS } from 'src/constants/CommonConstants';
import { TargetDefaultProps } from 'src/containers/target-container/TargetPropTypes';
import { cloneDeep } from 'lodash-es';
import { TARGET_ACTIONS } from '../actions/TargetActions';

const initialState = () => ({
    currentRecord: cloneDeep(TargetDefaultProps),
    currentRecordPopulated: cloneDeep(TargetDefaultProps),

    search: {
        data: [],
        currentPage: 0,
        pages: 0,
        count: 0,
    },

    upsertReqStatus: null,
    searchReqStatus: null,
});

export default (state = initialState(), action) => {
    switch (action.type) {
        // SEARCH
        case TARGET_ACTIONS.TARGET_SEARCH: {
            return {
                ...state,
                searchReqStatus: REQUEST_STATUS.PENDING,
            };
        }
        case TARGET_ACTIONS.TARGET_SEARCH_SUCCESS: {
            return {
                ...state,
                search: action.data,
                searchReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }
        case TARGET_ACTIONS.TARGET_SEARCH_ERROR: {
            return {
                ...state,
                searchReqStatus: REQUEST_STATUS.ERROR,
            };
        }

        // UPSERT
        case TARGET_ACTIONS.TARGET_UPSERT: {
            return {
                ...state,
                upsertReqStatus: REQUEST_STATUS.PENDING,
            };
        }
        case TARGET_ACTIONS.TARGET_UPSERT_SUCCESS: {
            return {
                ...state,
                currentRecord: action.data,
                upsertReqStatus: REQUEST_STATUS.SUCCESS,
            };
        }
        case TARGET_ACTIONS.TARGET_UPSERT_ERROR: {
            return {
                ...state,
                upsertReqStatus: REQUEST_STATUS.ERROR,
            };
        }

        case TARGET_ACTIONS.TARGET_POPULATED_RECORD_UPDATE: {
            return {
                ...state,
                currentRecordPopulated: action.data,
            };
        }

        // RESET
        case TARGET_ACTIONS.TARGET_RESET: {
            return initialState();
        }
        default:
            return state;
    }
};
